import {lazy} from 'react';

export const FundScenariosLazy = lazy(() => import(/* webpackChunkName: "fundScenarios" */ '.'));
